// extracted by mini-css-extract-plugin
export default {"content":"style_content__GP-Z4","loaderWrapper":"style_loaderWrapper__IUbXV","loader":"style_loader__WR2JK"};